import React, { useState, useEffect } from "react";
import {loadStripe} from '@stripe/stripe-js';
import { useDispatch, useSelector } from "react-redux";
import { createCheckoutSessionThunk } from "../store/stripe";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./StripeCheckoutForm.js";




const stripePromise = loadStripe("pk_live_51N1jsSIzDtG53Sp0IYroac8Yq8aSbX7PQgISERDGaQNviBMnz4SGJ4RhjZws64QrELl0aJoWqtyYe5W3Ud6bqhmV00sR5crhK1", { 
    // stripeAccount:'acct_1RE0ShG0QB8rARAi' 
  });


  const CheckoutApp = ({tip, customTip, aptNumber, deliveryInstructions, email, restaurantId, name, phone, cartItems, coupon, address, selectedTime, freeItem, rewardItem}) => {
    const dispatch = useDispatch();
    const clientSecret = useSelector((state) => state?.stripe?.data?.clientSecret);
    
    useEffect(() => {
    dispatch(createCheckoutSessionThunk(tip, customTip,restaurantId, cartItems, coupon, address, name, phone, selectedTime, freeItem, rewardItem, email, aptNumber, deliveryInstructions))
  
    }, [dispatch]);
  
    const appearance = {
      theme: 'flat',
    };
    const options = {
      clientSecret,
      appearance,
    };

  
  
    return (
      <div >
        {clientSecret && (
          <Elements options={options} stripe={stripePromise}>
            <CheckoutForm />
          </Elements>
        )}
      </div>
    );
  }

export default CheckoutApp;
